import { getAuth } from 'firebase/auth';

export function firebaseUtil() {
  return {
    getIdToken,
  };
}

async function getIdToken() {
  return (await getAuth().currentUser?.getIdTokenResult())?.token;
}
